<template>
    <form @submit.prevent="submitSearch">
        <div class="header__search">
            <div class="header__search__form">
                <button type="button" class="header__search__icon icon-search" @click="searchIconClicked"></button>
                <input
                    v-model="term"
                    type="text"
                    class="header__search__input"
                    :placeholder="appData.dictionary.placeholder"
                    autocomplete="off"
                    @focus="showHistory" />
                <a href="javascript:void(0)" class="header__search__close icon-close" @click="closeSearch"></a>
            </div>
            <div v-if="searchHistory.length" ref="search-history" class="header__search__history">
                <ul>
                    <li
                        v-for="(item, i) in searchHistory"
                        :key="'search-history-' + i"
                        @click="historyItemClicked(item)">
                        {{ item }}
                    </li>
                </ul>
            </div>
        </div>
    </form>
</template>

<script>
import * as lib from 'Root/lib/lib.js'

export default {
    data() {
        return {
            term: '',
            searchHistory: [],
            localStorageHistoryKey: 'search-history',
            maxHistoryItems: 10,

            isHeaderBar: false,
            searchOpen: false,

            searchOpenClass: 'search-open',
        }
    },

    mounted() {
        this.isHeaderBar = $(this.$el).parents('.header__bar').length

        this._getSearchHistory()
        this._iniSearchToggle()
    },

    methods: {
        _iniSearchToggle() {
            this.searchBar = document.querySelector('.header__bar__search')

            $(document).on('click', (e) => {
                if (!$(e.target).closest('.header__search').length) {
                    this.closeSearch()
                }
            })

            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    this.closeSearch()
                }
            })
        },

        openSearch() {
            if (this.isHeaderBar) {
                this.searchBar.classList.add(this.searchOpenClass)
                this.searchOpen = true
            }
        },

        closeSearch() {
            if (this.isHeaderBar) {
                this.searchBar.classList.remove(this.searchOpenClass)
                this.searchOpen = false
            }
            this.hideHistory()
        },

        showHistory() {
            $(this.$refs['search-history']).slideDown()
        },

        hideHistory() {
            $(this.$refs['search-history']).slideUp()
        },

        searchIconClicked() {
            this.isHeaderBar && !this.searchOpen ? this.openSearch() : this.submitSearch()
        },

        historyItemClicked(term) {
            this.term = term
            this.submitSearch()
        },

        submitSearch() {
            if (this.term.length) {
                this._storeSearchTerm()

                const redirectUrl = `${this.appData.configuration.resultsBaseUrl}?term=${this.term}`
                window.location.href = redirectUrl
            }
        },

        _storeSearchTerm() {
            const existingTermIndex = this.searchHistory.indexOf(this.term)
            if (existingTermIndex > -1) {
                this.searchHistory.splice(existingTermIndex, 1)
            }

            this.searchHistory.push(this.term)
            this.searchHistory = this.searchHistory.slice(-this.maxHistoryItems)
            window.localStorage.setItem(this.localStorageHistoryKey, this.searchHistory.join('|'))
        },

        _getSearchHistory() {
            const localStorageHistory = window.localStorage.getItem(this.localStorageHistoryKey)

            if (lib.hasValue(localStorageHistory)) {
                localStorageHistory.split('|').forEach((item) => {
                    this.searchHistory.push(item)
                })
            }
        },
    },
}
</script>
